import * as Styles from './EmptyState.styles';

export type EmptyStateProps = {
  /** Optional icon component rendered above the title. */
  icon?: React.ElementType;
  /** Primary message displayed prominently. */
  title: string;
  /** Optional secondary description below the title. */
  description?: string;
  /** Optional call-to-action button rendered below the description. */
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ElementType;
  };
};

const EmptyState = function ({
  icon: Icon,
  title,
  description,
  action,
}: EmptyStateProps): JSX.Element {
  const ActionIcon = action?.icon;

  return (
    <Styles.Wrapper>
      {Icon && (
        <Styles.IconWrapper>
          <Icon style={{ fontSize: 'inherit' }} />
        </Styles.IconWrapper>
      )}

      <Styles.Title>{title}</Styles.Title>

      {description && (
        <Styles.Description $hasAction={!!action}>
          {description}
        </Styles.Description>
      )}

      {action && (
        <Styles.ActionButton onClick={action.onClick}>
          {ActionIcon && <ActionIcon style={{ fontSize: 16 }} />}
          {action.label}
        </Styles.ActionButton>
      )}
    </Styles.Wrapper>
  );
};

export default EmptyState;
